const BASE_URL = '/authentication/access';

export class AccessRightService {
    /* @ngInject */
    constructor(egUrlService, $http) {
        this.egUrlService = egUrlService;
        this.$http = $http;
    }

    hasAnyAccess(accessRightsList){
        let url = this.egUrlService.url(`${BASE_URL}`);

        return this.$http.post(url, accessRightsList)
            .then(response => response.data);
    }

    hasAnyAccessOrRedirect($state, accessRightsList) {
        return this.hasAnyAccess(accessRightsList)
            .then((response) => {
                if (!response) {
                    $state.go('accessDenied');
                }
            });
    }

    resolveAccessRights(accessRightsList) {
        let url = this.egUrlService.url(`${BASE_URL}/resolve`);

        return this.$http.post(url, accessRightsList)
            .then(response => response.data);
    }
}